module.exports = __webpack_public_path__ + "img/heureux.02543668.png";